import * as React from 'react'
import Label from '../components/label'
import { css } from '@emotion/react'

const Event = () => {
  return (
    <section css={sectionStyle}>
      <div css={sectionInnerStyle}>
        <Label labelTitle={'現在開催中の展示'} />
        <div css={eventStyle}>
          <h3 css={eventTitleStyle}>Coming Soon</h3>
          <p css={eventTextStyle}>
            ただいま予定しているイベントはございません。
            <br />
            次回開催までしばらくお待ちください。
          </p>
        </div>
      </div>
    </section>
  )
}

const sectionStyle = css`
  width: 100%;
  margin-top: 88px;
  @media (max-width: 768px) {
    margin-top: 68px;
  }
`
const sectionInnerStyle = css`
  width: 1024px;
  margin: 0 auto;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0 24px;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`
const eventStyle = css`
  padding-top: 48px;
  text-align: center;
`
const eventTitleStyle = css`
  font-size: 6.4rem;
  font-weight: 700;
  @media (max-width: 768px) {
    font-size: 3.2rem;
  }
`
const eventTextStyle = css`
  padding-top: 16px;
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.8;
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`

export default Event
